export default {
  name: 'Spdex'
};